// What Laila's streamed chat (the lailaChat Lambda) sends while it answers.
export type LailaChatEvent =
  // A tool or the help-centre search started; `label` is fit to show.
  | { type: 'status'; tool: string; label?: string }
  // The next piece of the answer.
  | { type: 'delta'; text: string }
  // Something a tool has to show, drawn under the answer. A card with the id
  // of one already shown replaces that one, wherever it is in the chat.
  | { type: 'card'; id: string; kind: string; data: Record<string, unknown> }
  // Voice mode: the next sentence spoken, as a base64-encoded MP3, or with
  // audioFormat "pcm" the next piece of it, as base64 16-bit mono PCM.
  | { type: 'audio'; seq: number; text: string; mp3?: string; pcm?: string; sampleRate?: number }
  // The whole answer; `responseId` continues the conversation.
  | { type: 'done'; responseId: string; text: string }
  | { type: 'error'; message: string };

const EVENT_TYPES = new Set(['status', 'delta', 'card', 'audio', 'done', 'error']);

// Splits a Server-Sent Events buffer into the complete events and the
// unfinished tail, which waits for the next chunk.
export const parseSse = (buffer: string): { events: LailaChatEvent[]; rest: string } => {
  const blocks = buffer.split('\n\n');
  const rest = blocks.pop() ?? '';
  const events: LailaChatEvent[] = [];
  blocks.forEach(block => {
    let type = '';
    let data = '';
    block.split('\n').forEach(line => {
      if (line.startsWith('event:')) {
        type = line.slice(6).trim();
      } else if (line.startsWith('data:')) {
        data += line.slice(5).trim();
      }
    });
    if (EVENT_TYPES.has(type) && data) {
      try {
        events.push({ type, ...JSON.parse(data) });
      } catch (e) {
        // A malformed event is skipped; the stream still ends with done or error.
      }
    }
  });
  return { events, rest };
};
